import angular from "angular";
import OsobaService from "./OsobaService";
import { EditCtrl } from "../Editor";

export default angular
.module("energis.osoba", [])
.config(function routes($stateProvider){
  $stateProvider
  .state("osoba-edit", {
    url: "/osoby/{id:int}/edit",
    template: require("./osoba.edit.html"),
    controller: EditCtrl,
    controllerAs: "ctrl",
    resolve: {
      item: ($stateParams, OsobaService) => OsobaService.get($stateParams.id),
      saveHandler: (OsobaService) => (id, item) => OsobaService.save(id, item)
    }
  })
  .state("osoba-create", {
    url: "/kontakty/{kontaktId:int}/osoby/nova",
    template: require("./osoba.edit.html"),
    controller: EditCtrl,
    controllerAs: "ctrl",
    resolve: {
      item: ($stateParams, OsobaService) => OsobaService.create($stateParams.kontaktId),
      saveHandler: (OsobaService) => (id, item) => OsobaService.save(id, item)
    }
  })
})
.service("OsobaService", OsobaService)
.name;



// WEBPACK FOOTER //
// ./src/Osoba/index.js